<template>
  <div class="stream-blocks-container">
    <p v-if="isAll == false && $store.state.org.concepts.length == 0" style="text-align: center;">Fetching events...</p>
    <p v-if="isAll == true && $store.state.org.allConcepts.length == 0" style="text-align: center;">Fetching events...</p>
    <div class="event" v-for="(eventObj, index) in streamEvents.slice(0, maxShowCount)" :key="index">
      <p class="event__details">{{ eventObj.uploader }} added {{ blockSummaryLabel(eventObj) }} to <span class="clickable" @click="goToEventConcept(eventObj)">{{ getConceptName(eventObj.concept) }}</span></p>
      <div class="stream-blocks">
        <Block
          v-for="(block, index) in eventObj.ideas"
          v-bind:block="block"
          v-bind:index="index"
          v-bind:key="block.id"
          v-bind:viewActions="false"
          small="small"
          v-bind:inConceptId="eventObj.concept"
        ></Block>

        <Block
          v-for="(block, index) in eventObj.references"
          v-bind:block="block"
          v-bind:index="index"
          v-bind:key="block.id"
          v-bind:viewActions="false"
          small="small"
          v-bind:inConceptId="eventObj.concept"
        ></Block>
      </div>
    </div>

    <button v-if="maxShowCount < streamEvents.length" @click="showMore">Show more events</button>
    <p v-if="maxShowCount >= streamEvents.length">That's all {{ streamEvents.length }} events!</p>
  </div>
</template>

<script>
import Block from '@trust/components/Block.vue'

export default {
  name: 'Stream',
  components: {
    Block,
  },
  data() {
      return {
        showCount: 10,
      }
  },
  props: ['blocks', 'isAll'],
  computed: {
    streamEvents(){
      let events = [];

      // go through blocks
      // get block
      //   start event
      //   set event's end time
      //   set event's uploader
      // keep going through blocks
      //   adding ideas and references to event
      //   if event is 30 min past OR if uploader is different
      // start new event

      if(!this.blocks){
        return [];
      }

      let blocks = this.blocks;
      blocks.sort(function(a, b) {
        if (a.createdAt > b.createdAt) return -1;
        if (a.createdAt < b.createdAt) return 1;
        return 0;
      });

      let currentEvent = null;
      blocks.forEach(block => {
        let startNewEvent = false;

        if(currentEvent == null) {
          startNewEvent = true;

        } else {
          // see if we should add to event
          const half_hour = (60 * 60 * 1000) * 0.5; // in milliseconds
          let isOutsideTime = (block.createdAt - currentEvent.endTime) > half_hour;

          if(block.uploader != currentEvent.uploader || block.concepts[0] != currentEvent.concept || isOutsideTime) {
            events.push(currentEvent);
            startNewEvent = true;
          }
        }

        // start new event
        if(startNewEvent == true){
          currentEvent = {
            concept: block.concepts[0],
            uploader: block.uploader,
            endTime: block.createdAt,
            ideas: [],
            references: [],
          }
        }

        // add to event
        if(block.type == 'Idea'){
          currentEvent.ideas.push(block);
        } else if (block.type == 'Reference') {
          currentEvent.references.push(block);
        }
      })

      console.log(events)
      return events;
    },
    maxShowCount(){
      if(this.showCount < this.streamEvents.length){
        return this.showCount;
      } else {
        return this.streamEvents.length;
      }
    }
  },
  mounted() {
  },
  methods: {
    goToEventConcept(eventObj){
      let conceptName = this.getConceptName(eventObj.concept);
      let conceptGroup = this.getConceptGroup(eventObj.concept);
      let slug = encodeURIComponent(conceptName.toLowerCase());
      if(conceptGroup != null){
        this.$store.dispatch('routing/goToConcept', { slug, group: conceptGroup }, {root: true});
      } else {
        this.$store.dispatch('routing/goToConcept', { slug }, {root: true});
      }
      this.$store.dispatch('closeRight');
    },
    blockSummaryLabel(eventObj){
      let str = '';
      if(eventObj.ideas.length > 0){
        str += eventObj.ideas.length + ' Idea';
        if(eventObj.ideas.length > 1){ str += 's'}
      }

      if(eventObj.ideas.length > 0 && eventObj.references.length > 0){
        str += ' and ';
      }

      if(eventObj.references.length > 0){
        str += eventObj.references.length + ' Reference';
        if(eventObj.references.length > 1){ str += 's'}
      }

      return str;
    },
    getConceptName(id){
      let concept;
      if(this.isAll){
        concept = this.$store.state.org.allConcepts.filter(c => c.id == id);
      } else {
        concept = this.$store.state.org.concepts.filter(c => c.id == id);
      }

      if(concept.length > 0){
        return concept[0].name;
      } else {
        return '[ N/A ]';
      }
    },
    getConceptGroup(id){
      let group = null;
      if(this.isAll){
        let concept = this.$store.state.org.allConcepts.filter(c => c.id == id);
        group = concept[0].group;
      }

      return group;
    },
    // getConceptGroup(id){
    //   let concept = this.$store.state.org.allConcepts.filter(c => c.id == id);
    //   if(concept.length > 0){
    //     console.log(concept[0])
    //     return concept[0].name;
    //   } else {
    //     return '[ N/A ]';
    //   }
    // },
    showMore(){
      this.showCount += 10;
    }
  },
}

</script>

<style>

.event {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 4rem;
}

.event .stream-blocks {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
}

.event .stream-blocks .block {
  margin-top: 0;
  padding: 10px;
  max-width: 30%;
}

.event .clickable {
  font-weight: 500;
  color: var(--beige-700);
  transition: all 200ms ease-in-out;
}

.event .clickable:hover {
  cursor: pointer;
  color: var(--beige-1000);
}

.event-mobile-show {
  display: none;
}


@media (max-device-width: 600px) {
  .event .stream-blocks {
    display: grid;
    grid-template-columns: 1fr;
    overflow: hidden;
  }

  .event .stream-blocks .block {
    max-width: 100%;
    padding: 10px 0;
  }

  .event .event__details {
    text-align: center;
  }

  .event-mobile-show {
    display: inline;
  }

}

@media screen and (max-device-width: 600px) and (orientation:landscape) {
  .event .stream-blocks {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 10px;
  }
}

</style>
